import { Navbar } from "../../Components/Navbar/Navbar"
import { useLocation } from "react-router-dom";
import { gql, useQuery } from "@apollo/client";
import { GiHamburgerMenu } from "react-icons/gi"

import { CardProject } from "../../Components/CardProject/CardProject";

const GetAnotherProject = gql `
query MyQuery($_eq: Int!) {
  porto_projects(where: {_not: {id: {_eq: $_eq}}}, limit: 3) {
    content
    description
    id
    image_cover
    title
    link
    tags {
      tag {
        id
        name
      }
      id
    }
  }
}


`

export const ProjectDetail = () => {

  const location = useLocation();
  const {id, title, description, content, image_cover, link, tags} = location.state;

  const {data, loading, error} = useQuery(GetAnotherProject, {variables: { _eq: id}})
  console.log(data)
  
  return(
    <div>
      <nav className="navbar navbar-expand-lg sticky-top navbar-custom">
        <div className="container">
          <a className="navbar-brand text-black" href="/">Faiz</a>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
            <GiHamburgerMenu/>
          </button>
          <div className="collapse navbar-collapse justify-content-end" id="navbarNav">
            <ul className="navbar-nav">
              <li className="nav-item">
                <a className="nav-link text-black" aria-current="page" href="/">Back to Home</a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      <div className="mb-51">
        <div className="container">
          <div className="my-24">
            <img alt={title} src={image_cover} className="mx-auto rounded-6"></img>
          </div>
          <div>
            <h1 className="text-28 font-600">{title}</h1>
            <p className="text-justify">{description}</p>
            <p className="text-justify">{content}</p>
            <p className="text-justify">Link : <a target="_blank" href={link} className="underline cursor-pointer text-black hover:font-semibold duration-100">{link}</a></p>
            <h6 className="text-13">Build Using</h6>
            <div className="flex justify-start gap-2">
              {tags?.map((tag) => 
                <div className="border w-fit py-1 px-2 rounded-md">
                  <p className="text-9 m-0">{tag.tag.name}</p>
                </div>
              )}
            </div>
          </div>
          <div className="mt-20">
            <p className="text-20 font-500">Another Projects</p>
            <div className="mt-20">
              <div className="w-full grid lg:grid-cols-3 gap-20">
                {data?.porto_projects.map((project) => <CardProject key={project.id} items={project}/>)}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="text-center text-8 py-10 container copyright-container">
        <p className="m-0">Copyright © 2022 Faiz All Rights Reserved</p>
      </div>
    </div>
  )
}